import { BalanceSheetMonthlyData } from "@/types/balance-sheet-monthly.api";
import { api, withErrorHandling } from "./api";
import qs from 'qs';

export const getBalanceSheetMonthly = async (
    clientId: string,
    connectionIds: string[],
    months: number[],
    year: number
): Promise<BalanceSheetMonthlyData> => {
    const response = await withErrorHandling(() =>
        api.get<BalanceSheetMonthlyData>(`/clients/${clientId}/report/balance-sheet/monthly-graph`, {
            params: {
                clientId: clientId,
                connectionIds: connectionIds[0],
                Year: year,
                Month: months[months.length - 1],
            },
            paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
        })
    );

    return response.data;
};
